import React from 'react';
import {Helmet} from 'react-helmet';

const JsonLD = () => {
  const structuredData = {
    "@context": "http://schema.org",
    "@type": "Service",
    "serviceType": "Trading Options Like The Pros",
    "provider": {
      "@type": "Organization",
      "name": "Trading Options Like The Pros",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@tradingoptionslikethepros.com",
        "contactType": "Customer Service"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default JsonLD;
